import api from "../axios";

/**
 * Generate AI content for specified fields
 * @param {Object} params - Generation parameters
 * @param {string} params.module - Module name (e.g., 'hse_document')
 * @param {Object} params.context - Context fields to include in prompt
 * @param {Array<string>} params.fields_to_generate - Fields to generate
 * @param {string} params.provider - AI provider ('grok' or 'chatgpt')
 * @param {Object} params.options - Additional options (language, tone, length, etc.)
 */
export const generateAIContent = async (params) => {
  const response = await api.post("/ai_generator/generate", params);
  return response.data;
};

/**
 * Get configuration for a module
 * @param {string} module - Module name
 */
export const getAIGeneratorConfig = async (module) => {
  const response = await api.get(`/ai_generator/config/${module}`);
  return response.data;
};
